import { Navigate } from 'react-router-dom';
import { ROUTES } from '../constants/FrontendPathConstants';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

  // DEV BYPASS 
  // const devBypass =
  //   (import.meta.env.DEV && import.meta.env.VITE_DEV_BYPASS === '1') ||
  //   localStorage.getItem('DEV_BYPASS_AUTH') === '1';

  if (!isAuthenticated /* && !devBypass */) {
    return <Navigate to={ROUTES.SIGNUP} replace />;
  }
  return <>{children}</>;
};
